import React, { Component } from 'react';

class Checkbox extends Component {
    render() {
        const {
            onChange,
            name,
            value,
            onBlur,
            disabled,
            hidden
        } = this.props;
        return (
            <span className={`${hidden ? 'd-none':''}`}>
                <input
                    type="checkbox"
                    defaultValue={value}
                    checked={value}
                    name={name}
                    onClick={onBlur}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span onClick={onBlur}> {name}</span>&nbsp; &nbsp; &nbsp; &nbsp;
            </span>
        );
    }
}

export default Checkbox;